import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import Cookies from "universal-cookie";
import { func, bool, array, string, object } from "prop-types";

import VerticalMenubar from "../VerticalMenubar";
import NavbarSearch from "../NavbarSearch";
import { Facebook, Twitter } from "../../../atoms/icons/StoryPageIcons";
import { micrositeStyles } from "./header-utils";
import HamburgerIcon from "../../../atoms/icons/hamburger";
import { setVerticalMenuBar, setMobileFilter, setMember, setJwtToken, setBookmark } from "../../../helper/actions";
import { useDeviceWidth, logoRenderer } from "../../../utils/react-utils";
import SearchIcon from "../../../atoms/icons/search-icon";
import MobileLogo from "../../../atoms/MobileLogo";
import { getUser, getJwt } from "../../../helper/api";
import truncate from "lodash/truncate";
import StoryPageMetaDataIcons from "../../../molecules/StoryPageMetaDataIcons";
import DesktopLogo from "../../../atoms/DesktopLogo";
import Dropdown from "../../../atoms/Dropdown";
import { staticTexts } from "../../../utils/Translate";
import { listValue } from "../../../utils/constant";
import {
  getSectionsDataForHeader,
  getDomainSectionInfo,
  getDomainHostUrl,
  getCurrentSite,
  trimLastSlash,
} from "../../../utils/utils";
import MenuItems from "./MenuItems";
import BellContainer from "./BellContainer";
import PopupOverlay from "../../../molecules/PopupOverlay";
import { MICROSITES } from "../../../../../server/helpers/constants";

import "./newHeader.m.css";

const { BroadcastChannel } = require("broadcast-channel");

const NewHeader = ({
  domainMenuItemsObj,
  publisherAttributes,
  isVerticalMenubar,
  currentPath,
  setVerticalMenuBar,
  setMobileFilter,
  domainSlug,
  pageType,
  story,
  collection,
  sections,
  domains,
  navigateToPage,
  member,
  setMember,
  setJwtToken,
  setBookmark,
}) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [showSearchIcon, setShowSearchIcon] = useState(true);
  const [dot, setDot] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [domainStyle, setDomainStyle] = useState({});
  const [hamburgerMenu, setHamburgerMenu] = useState({});
  const [stickyHeader, setStickyHeader] = useState(false);
  const [domainSectionObj, setSectionDomainObj] = useState({});
  const [sectionMenuItem, setSectionMenuItem] = useState(null);
  const [sectionsDataForHeader, setSectionsDataForHeader] = useState(null);
  const [verifySuccess, setVerifySuccess] = useState(false);
  const [showPopUp, setShowPopup] = useState(true);
  const [message, setMessage] = useState("");
  const [location, setLocation] = useState(null);

  const isSectionPage = pageType === "section-page" || pageType === "collection-page";
  const isStoryPage = pageType === "story-page";
  const isHomePage = pageType === "home-page";
  const currentSite = getCurrentSite(currentPath);

  const channel = new BroadcastChannel("logout-channel");

  useEffect(() => {
    channel.onmessage = (msg) => {
      setMember(null);
      setJwtToken(null);
      setBookmark(null);
    };
  });

  const isDomain = (domainName) => {
    return domainSlug === domainName || currentSite === domainName;
  };

  const isStorySection = (!isDomain("protichinta") && !stickyHeader) || isDomain("protichinta");

  const isDefaultHeader = () => {
    if (!(isStoryPage || isSectionPage || isHomePage)) {
      return true;
    }

    return false;
  };

  const setDomainData = (domainName) => {
    setDomainStyle(micrositeStyles[domainName] || {});
    setSectionDomainObj(getDomainSectionInfo(domainName, sections));
  };

  const cookies = new Cookies();

  const ref = useRef(null);
  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShowSearchIcon(true);
    }
  };

  useDeviceWidth(setIsDesktop);

  const fetchNotifications = () => {
    const offset = 0;
    const limit = 4;

    fetch(`/feapi/push-engage-notifications?limit=${limit}&offset=${offset}`)
      .then((res) => res.json())
      .then((resp) => {
        setNotifications(resp.notifications);
        if (cookies.get("notifications") && resp.notifications.length > 0) {
          resp.notifications[0].notification_id !== cookies.get("notifications") ? setDot(true) : setDot(false);
        } else {
          setNotifications(resp.notifications);
          resp.notifications.length > 0 && setDot(true);
        }
      });
  };

  const updateSectionMenuItem = (sectionsData, menuItems) => {
    if (sectionsData.parentSection) {
      if (
        domainSlug &&
        trimLastSlash(getDomainHostUrl(domainSlug, domains)) === trimLastSlash(sectionsData.parentSectionUrl)
      ) {
        const menuItem = menuItems.find(
          (item) => trimLastSlash(item.completeUrl) === trimLastSlash(sectionsData.currentSectionUrl)
        );
        setSectionMenuItem(menuItem);
      } else {
        const menuItem = menuItems.find(
          (item) => trimLastSlash(item.completeUrl) === trimLastSlash(sectionsData.parentSectionUrl)
        );
        setSectionMenuItem(menuItem);
      }
    } else {
      const menuItem = menuItems.find(
        (item) => trimLastSlash(item.completeUrl) === trimLastSlash(sectionsData.currentSectionUrl)
      );
      setSectionMenuItem(menuItem);
    }
  };

  const changePopupView = () => {
    const isHashPresent = global.location.href.substr(0, global.location.href.indexOf("#"));
    const finalRedirectUrl = new URL(isHashPresent);
    navigateToPage(finalRedirectUrl.pathname || "/");
    setShowPopup(false);
  };

  useEffect(() => {
    !showSearchIcon && toggleSearchIcon();
    showNotifications && setShowNotifications(!showNotifications);
    stickyHeader && setStickyHeader(!stickyHeader);
    isVerticalMenubar && setVerticalMenuBar(!isVerticalMenubar);

    if (pageType && global.location && global.location.hash === "#email-verification") {
      setVerifySuccess(true);
    }

    if (pageType && global.location) {
      if (global.location.hash === "#email-verified") {
        setVerifySuccess(true);
        setMessage("Email verified.");
      } else if (global.location.hash === "#token-consumed") {
        setVerifySuccess(true);
        setMessage("The verification link is already used.");
      } else if (global.location.hash === "#invalid-token") {
        setVerifySuccess(true);
        setMessage("The verification link is invalid. Please request for a new link.");
      } else if (global.location.hash === "#internal-error") {
        setVerifySuccess(true);
        setMessage("Something went wrong. Please try again.");
      }
    }
  }, [pageType]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    document.addEventListener("scroll", () => setShowSearchIcon(true));
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
      document.removeEventListener("scroll", () => setShowSearchIcon(true));
      !showSearchIcon && toggleSearchIcon();
    };
  });

  useEffect(() => {
    isVerticalMenubar
      ? (global.document.body.style.overflow = "hidden")
      : (global.document.body.style.cssText = "overflow-x: hidden, overflow-y: auto");
  }, [isVerticalMenubar]);

  useEffect(() => {
    fetchNotifications();
    setVerticalMenuBar(false);
    setLocation(getCurrentSite(global.location.host));

    isVerticalMenubar && setVerticalMenuBar(false);
    const interval = setInterval(() => {
      fetchNotifications();
    }, 150000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    isVerticalMenubar && setVerticalMenuBar(false);
  }, [sectionsDataForHeader]);

  useEffect(() => {
    if (domainSlug) {
      setDomainData(domainSlug);
    }
  }, [domainSlug]);

  useEffect(() => {
    if (currentSite && MICROSITES.includes(currentSite)) {
      setDomainData(currentSite);
    }
  }, [currentPath]);

  useEffect(() => {
    if (domainMenuItemsObj.length > 0) {
      const hamItems = domainMenuItemsObj.find((item) => item.title === "hamburger");
      setHamburgerMenu(get(hamItems, ["children"], []));

      if (isSectionPage) {
        const menu = domainMenuItemsObj.find((item) => item.title === "sections");
        const menuItems = menu ? menu.children : [];

        const sectionsData =
          collection.template !== "default"
            ? getSectionsDataForHeader(
                sections,
                domainSlug,
                collection.metadata.section,
                getDomainSectionInfo(domainSlug, sections)
              )
            : null;

        setSectionsDataForHeader(sectionsData);

        if (sectionsData) {
          updateSectionMenuItem(sectionsData, menuItems);
        }
      }
    }
  }, [domainMenuItemsObj]);

  const handleScroll = () => (window.pageYOffset > 350 ? setStickyHeader(true) : setStickyHeader(false));

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, false);
    return () => {
      window.removeEventListener("scroll", handleScroll, false);
    };
  }, [pageType]);

  const headline = story.headline
    ? truncate(story.headline, {
        length: 80,
      })
    : "";

  const toggleSearchIcon = () => setShowSearchIcon(!showSearchIcon);

  const toggleVerticalMenubar = () => {
    setVerticalMenuBar(!isVerticalMenubar);
    setMobileFilter(false);
  };

  const toggleNotifications = () => {
    if (!showNotifications) {
      cookies.set("notifications", notifications.length && notifications[0].notification_id);
      setDot(false);
    }

    setShowNotifications(!showNotifications);
  };

  const multiDomainWrapperName = () => {
    if (location === "protichinta" || isDomain("protichinta")) {
      return "protichinta-wrapper";
    } else if (location === "kishoralo" || isDomain("kishoralo")) {
      return "kia-wrapper";
    } else if (location === "bondhushava" || isDomain("bondhushava")) {
      return "bondhushava-wrapper";
    } else if (location === "nagorik-sangbad" || isDomain("nagorik-sangbad")) {
      return "nagorik-wrapper";
    } else if (location === "bigganchinta" || isDomain("bigganchinta")) {
      return "bigganchinta-wrapper";
    } else if (location === "trust" || isDomain("trust")) {
      return "trust-wrapper";
    }
    return "";
  };

  const getDateFromUtils = () => {
    const currentDate = new Date();
    const locale = publisherAttributes.lang === "bn" ? "bn-BN" : "en";

    const year = currentDate.toLocaleString(locale, { year: "numeric" });
    const weekday = currentDate.toLocaleString(locale, { weekday: "long" });
    const month = currentDate.toLocaleString(locale, { month: "long" });
    const day = currentDate.toLocaleString(locale, { day: "numeric" });

    return (
      <React.Fragment>
        <span styleName="weekday">{weekday}, </span>
        <span>
          {day} {month} {year}
        </span>
      </React.Fragment>
    );
  };

  const pageBasedStickyWrapperName = () => {
    if (stickyHeader) {
      if (isStoryPage) {
        return "sticky-story-header";
      } else if (isSectionPage) {
        return "sticky-section-header";
      }
    }

    return "";
  };

  const protichintaBaseName = () => {
    if (isDomain("protichinta") && isSectionPage) {
      if (stickyHeader) {
        return "protichinta-sticky-section-header";
      }

      return "protichinta-section-header";
    }

    return "";
  };

  const getLogo = () => {
    if (!isDomain("protichinta")) {
      if (isHomePage) {
        return (
          <div styleName={`logo ${isVerticalMenubar ? "vertical-menu-bar-logo" : ""}`}>
            {isDesktop
              ? logoRenderer(
                  <DesktopLogo
                    domainSlug={domainSlug}
                    lang={publisherAttributes.lang}
                    pageType={pageType}
                    location={location}
                  />,
                  currentPath
                )
              : logoRenderer(<MobileLogo />, currentPath)}
          </div>
        );
      } else if (!stickyHeader || (stickyHeader && isDefaultHeader())) {
        return (
          <div
            styleName={`logo mobile-logo ${isVerticalMenubar ? "vertical-menu-bar-logo" : ""}`}
            className="print-logo"
          >
            {logoRenderer(<MobileLogo />, currentPath)}
          </div>
        );
      } else return null;
    }

    return null;
  };

  const baseStyleName = `${isHomePage ? "base home-page-base" : "base"} ${protichintaBaseName()} ${
    isDomain("kishoralo") ? "kia-base" : ""
  } ${isDefaultHeader() ? "default-header-base" : ""}`;

  const wrapperStyleName = `wrapper ${pageBasedStickyWrapperName()} ${multiDomainWrapperName()} ${
    isVerticalMenubar ? "hamburger-header" : ""
  }`;

  useEffect(() => {
    getUser()
      .then((response) => {
        setMember(response.member);
        const integrationsId = get(publisherAttributes, ["integrations_id"], null);
        if (response.member["verification-status"]) {
          getJwt(integrationsId).then((res) => {
            res.status === 200 && setJwtToken(res.headers.get("x-integration-token"));
          });
        }
      })
      .catch((ex) => console.log(ex.message));
  }, []);

  return (
    <div styleName={baseStyleName}>
      <div
        styleName={wrapperStyleName}
        className={`${multiDomainWrapperName()}`}
        style={{
          backgroundColor:
            isVerticalMenubar && !isDesktop ? domainStyle.hamburgerHeaderColor : domainStyle.primaryBgColor,
          display: domainStyle.display,
        }}
      >
        <div styleName="hamburger-search-wrapper" className="hamburger-search-wrapper">
          <div styleName="search-ham" className="search-ham">
            {(!isVerticalMenubar || (isDesktop && stickyHeader)) && !currentPath && (
              <HamburgerIcon
                onMenuToggle={toggleVerticalMenubar}
                isNavbarOpen={!!isVerticalMenubar}
                isDesktop={isDesktop}
                hamburgerStyle={{ backgroundColor: domainStyle.hamburgerColor }}
              />
            )}
            {isDomain("protichinta") && (
              <div styleName={`protichinta-logo-wrapper ${isSectionPage ? "protichinta-section-logo-wrapper" : ""}`}>
                <div
                  styleName={`logo ${stickyHeader ? "story-page-sticky-logo" : ""} ${
                    isVerticalMenubar ? "vertical-menu-bar-logo" : ""
                  }`}
                >
                  {(isHomePage && isDesktop) || (isDesktop && !stickyHeader && isSectionPage)
                    ? logoRenderer(
                        <DesktopLogo
                          domainSlug={domainSlug}
                          lang={publisherAttributes.lang}
                          pageType={pageType}
                          location={location}
                        />,
                        currentPath
                      )
                    : logoRenderer(<MobileLogo />, currentPath)}
                </div>
              </div>
            )}
            {!currentPath && !isDomain("protichinta") && (
              <>
                {showSearchIcon && (
                  <span styleName="search-icon" onClick={toggleSearchIcon}>
                    <SearchIcon color={domainStyle.searchColor} />
                  </span>
                )}
                <span ref={ref} styleName={!showSearchIcon ? "navbar-search" : ""}>
                  {!showSearchIcon && <NavbarSearch publisherAttributes={publisherAttributes} />}
                </span>
              </>
            )}
            {isStoryPage && isStorySection && (
              <div styleName="story-section" className="story-section">
                <Link href={story.sectionUrl}>{story.section}</Link>
              </div>
            )}
            {stickyHeader && (
              <>
                {!isDomain("protichinta") && (isStoryPage || isSectionPage) && (
                  <div
                    styleName={`logo story-page-sticky-logo ${
                      isVerticalMenubar ? "vertical-menu-bar-logo sticky-vertical-menu-bar-logo" : ""
                    }`}
                  >
                    {logoRenderer(<MobileLogo />, currentPath)}
                  </div>
                )}
                {isStoryPage && (
                  <div styleName="section-headline-wrapper">
                    {!isDomain("protichinta") && (
                      <div styleName="story-section" className="story-section">
                        <Link href={story.sectionUrl}>{story.section}</Link>
                      </div>
                    )}
                    <div
                      styleName={`story-headline ${publisherAttributes.lang}-headline`}
                      className="domain-story-headline"
                    >
                      {headline}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          {isDesktop && (isDomain("nagorik-sangbad") || !domainSlug) && isHomePage && (
            <time styleName={`date ${publisherAttributes.lang}-date`}>{getDateFromUtils()}</time>
          )}
        </div>
        {getLogo()}
        {!stickyHeader || (stickyHeader && isDefaultHeader() && isDesktop) ? (
          <div styleName="login-wrapper" className="print-logo-wrapper">
            <div styleName="bell-button">
              {isDomain("protichinta") && (
                <span styleName="protichinta-icons">
                  {!currentPath && showSearchIcon && (
                    <span styleName="protichinta-search-icon" onClick={toggleSearchIcon}>
                      <SearchIcon color={domainStyle.searchColor} width="18" height="18" />
                    </span>
                  )}
                  {!currentPath && (!isStoryPage || !isSectionPage) && (
                    <span ref={ref}>
                      {!showSearchIcon && <NavbarSearch publisherAttributes={publisherAttributes} />}
                    </span>
                  )}
                  <Link href="https://www.facebook.com/Protichinta/">
                    <Facebook color1={domainStyle.fbColor1} color2={domainStyle.fbColor2} />
                  </Link>
                  <Link href="https://twitter.com/Protichinta">
                    <Twitter color1={domainStyle.twitterColor1} color2={domainStyle.twitterColor2} />
                  </Link>
                </span>
              )}
              <BellContainer
                dot={dot}
                toggleNotifications={toggleNotifications}
                showNotifications={showNotifications}
                notifications={notifications}
                showLogin={publisherAttributes.showLogin}
                loginBorderStyle={domainStyle.loginBorder}
                loginTextStyle={domainStyle.loginText}
                bellIconStyle={domainStyle.bellIcon}
              />
            </div>
            {isDesktop && (!domainSlug || domainSlug === "northamerica") && isHomePage && (
              <Dropdown label={`${staticTexts(publisherAttributes.lang).edition}:`} list={listValue} />
            )}
          </div>
        ) : !isStoryPage ? null : (
          <StoryPageMetaDataIcons color1={domainStyle.socialIconBg} color2={domainStyle.fontColor} />
        )}
        {stickyHeader && (
          <div styleName="sticky-bell-login-container">
            <BellContainer
              dot={dot}
              toggleNotifications={toggleNotifications}
              showNotifications={showNotifications}
              notifications={notifications}
              showLogin={publisherAttributes.showLogin}
              loginBorderStyle={domainStyle.loginBorder}
              loginTextStyle={domainStyle.loginText}
              bellIconStyle={domainStyle.bellIcon}
            />
          </div>
        )}
        {stickyHeader && isSectionPage && (
          <MenuItems
            domainSectionObj={domainSectionObj}
            domainSlug={domainSlug}
            language={publisherAttributes.lang}
            sectionsDataForHeader={sectionsDataForHeader}
            sectionMenuItem={sectionMenuItem}
            multiDomainWrapperName={multiDomainWrapperName()}
            collection={collection}
            pageType={pageType}
          />
        )}
      </div>
      {isVerticalMenubar && (
        <VerticalMenubar
          isVerticalMenubar={isVerticalMenubar}
          isDesktop={isDesktop}
          toggleVerticalMenubar={toggleVerticalMenubar}
          hamburgerMenu={hamburgerMenu}
          domainSlug={domainSlug}
        />
      )}
      {verifySuccess && showPopUp && member && (
        <PopupOverlay
          lang={publisherAttributes.lang}
          popupMessage={message}
          onClickHandler={changePopupView}
          buttonType="continue"
          buttonContent="Continue"
        />
      )}
      {verifySuccess && !member && showPopUp && (
        <PopupOverlay
          lang={publisherAttributes.lang}
          popupMessage={message}
          buttonType="login"
          buttonContent="Continue"
        />
      )}
    </div>
  );
};

NewHeader.propTypes = {
  setVerticalMenuBar: func,
  isVerticalMenubar: bool,
  domainSlug: string,
  publisherAttributes: object,
  currentPath: string,
  setMobileFilter: func,
  domainMenuItemsObj: array,
  story: object,
  pageType: string,
  collection: object,
  sections: array,
  domains: array,
  navigateToPage: func,
  member: object,
  setMember: func,
  setJwtToken: func,
  setBookmark: func,
};

const mapStateToProps = (state) => ({
  pageType: get(state, ["qt", "pageType"], ""),
  domainMenuItemsObj: get(state, ["qt", "data", "navigationMenu", "menuItems"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  isVerticalMenubar: get(state, ["settingsReducer", "isVerticalMenubar"], false),
  currentPath: get(state, ["currentPathReducer", "currentPath"], null),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  story: get(state, ["headerReducer", "showStoryHeader"], ""),
  collection: get(state, ["qt", "data", "collection"], {}),
  sections: get(state, ["qt", "config", "sections"], []),
  domains: get(state, ["qt", "config", "domains"], []),
  member: state.member || null,
});

const mapDispatchToProps = (dispatch) => ({
  setVerticalMenuBar: (flag) => dispatch(setVerticalMenuBar(flag)),
  setMobileFilter: (flag) => dispatch(setMobileFilter(flag)),
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
  setMember: (member) => dispatch(setMember(member)),
  setJwtToken: (token) => dispatch(setJwtToken(token)),
  setBookmark: (obj) => dispatch(setBookmark(obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewHeader);
